import { Stack } from '@rossum/ui/material';
import {
  AttachmentPreviewItem,
  useChatAttachments,
} from '../hooks/useChatAttachments';
import {
  DOCUMENT_TYPE_CONFIG,
  DOCUMENT_TYPE_FALLBACK,
  IMAGE_TYPE_CONFIG,
  IMAGE_TYPE_FALLBACK,
} from '../utils/attachments';
import { AttachmentPreview } from './AttachmentPreview';

type AttachmentListProps = {
  attachments: AttachmentPreviewItem[];
  onRemove: ReturnType<typeof useChatAttachments>['removeAttachment'];
};

const getConfig = <K extends string>(
  config: Partial<Record<K, { label: string; color: string }>>,
  mediaType: K,
  fallback: { label: string; color: string }
) => ({
  label: config[mediaType]?.label ?? fallback.label,
  labelColor: config[mediaType]?.color ?? fallback.color,
});

export const AttachmentList = ({
  attachments,
  onRemove,
}: AttachmentListProps) => {
  if (attachments.length === 0) return null;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      {attachments.map(item => {
        const config =
          item.kind === 'image'
            ? getConfig(IMAGE_TYPE_CONFIG, item.mediaType, IMAGE_TYPE_FALLBACK)
            : getConfig(
                DOCUMENT_TYPE_CONFIG,
                item.mediaType,
                DOCUMENT_TYPE_FALLBACK
              );

        return (
          <AttachmentPreview
            key={item.id}
            tooltipTitle={item.filename}
            thumbnailUrl={item.thumbnailUrl}
            isLoading={item.isLoading}
            onRemove={
              item.isLoading ? undefined : () => onRemove(item.id, item.kind)
            }
            dataCy="chat-remove-attachment-button"
            {...config}
          />
        );
      })}
    </Stack>
  );
};
